import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ImgRcVipGiftHistory } from '@/assets/pro';

import cx from 'clsx';
import { openGiftVipHistoryModal } from './GiftVipHistoryModal';
import { useQueryGiftVipHistoryList } from './hooks';
import style from './index.module.css';

const ThreeDayDuration = 3 * 24 * 60 * 60;

export const GiftVipHistory = ({
  className,
  currentUserAddrInfo,
  userId,
}: {
  className?: string;
  userId: string;
  currentUserAddrInfo?: UserInfo;
}) => {
  const { t } = useTranslation();
  const { data } = useQueryGiftVipHistoryList(userId);

  const hasRecentUpdate = useMemo(() => {
    const currentTime = new Date().getTime() / 1000;
    const latestGiftTime = data?.vip_list[0]?.create_at || 0;
    return latestGiftTime && currentTime - latestGiftTime < ThreeDayDuration;
  }, [data?.vip_list]);

  const handleClick = useCallback(() => {
    openGiftVipHistoryModal({
      userId,
    });
  }, [userId]);

  return (
    <div className={style.container}>
      <div className={cx(style.giftHistoryBtn, className)} onClick={handleClick}>
        {hasRecentUpdate ? (
          <span className={style.hasRecentUpdate}>{t('GiftVipHistory.new')}</span>
        ) : null}
        <ImgRcVipGiftHistory className={style.icon} />
        <span className={style.history}>{t('GiftVipHistory.history')}</span>
      </div>
    </div>
  );
};
